<div class="promotion-code-child-component">
  <h5>Basic Setting</h5>
  <div class="promotion-code-child-component-content">
    <form [formGroup]="form">
        <!-- Section 1 — identity + validity. Common to every promotion type. -->
        <div class="row">
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Code <span class="text-danger">*</span></span>
                <input type="text" class="form-control" formControlName="code" [ngClass]="isEditMode ? 'disabled' : ''" (input)="onCodeInput($event)" [placeholder]="initialData.promotion_type === 'Free Spin' ? 'e.g. FT_REL_88FS_GOO_5X' : ''" #focusfield/>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Name <span class="text-danger">*</span></span>
                <input type="text" class="form-control" formControlName="name"  (input)="onPreviewInput($event)" [placeholder]="initialData.promotion_type === 'Free Spin' ? 'e.g. Vm bonus 88 5XTO' : ''" />
                <ng-container *ngIf="initialData.promotion_type == 'BTG Promotion'">
                    <span class="reminder-text">
                        Phase 1: {{ namePreview }}-BTG-Phase-1 <br>
                        Phase 2: {{ namePreview }}-BTG-Phase-2
                    </span>
                </ng-container>
                <ng-container *ngIf="initialData.promotion_type == 'PP Promotion'">
                    <span class="reminder-text">
                        Phase 1: {{ namePreview }}-PP-Phase-1 <br>
                        Phase 2: {{ namePreview }}-PP-Phase-2
                    </span>
                </ng-container>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Linked Promotions</span>
                    <kt-dropdown-wo-lazyload
                        [form] = 'form'
                        [dropdownList] = 'promotionCodeDropdownList'
                        [dropdownSettings] = 'promotionCodeDropdownSettings'
                        [formName] = "'promotion_ids'"
                        [selectionAttributes] = "'id'"
                        [dataLoading]="isPromotionLoading"
                        [selectedItems] = 'promotionCodeSelectedItems'>
                    </kt-dropdown-wo-lazyload>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Valid From <span class="text-danger">*</span></span>
                <div class="input-group date">
                    <input class="hidden" [owlDateTime]="dateStartRef" [ngModel]="dateTimeStack?.valid_from_date" [ngModelOptions]="{standalone: true}">
                    <input type="text" formControlName="valid_from" class="form-control" placeholder="YYYY-MM-DD HH:mm:ss">
                    <span class="input-group-append" [owlDateTimeTrigger]="dateStartRef">
                        <span class="input-group-text pointer-calendar"><i class="far fa-calendar-alt"></i></span>
                    </span>
                    <owl-date-time #dateStartRef></owl-date-time>
                </div>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Valid To</span>
                <div class="input-group date">
                    <input class="hidden" [owlDateTime]="dateEndRef" [ngModel]="dateTimeStack?.valid_to_date" [ngModelOptions]="{standalone: true}">
                    <input type="text" formControlName="valid_to" class="form-control" placeholder="YYYY-MM-DD HH:mm:ss">
                    <span class="input-group-append" [owlDateTimeTrigger]="dateEndRef">
                        <span class="input-group-text pointer-calendar"><i class="far fa-calendar-alt"></i></span>
                    </span>
                    <owl-date-time #dateEndRef></owl-date-time>
                </div>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Status</span>
                <!-- Locked to Active while creating a Free Spin promotion (mirrors 3.2.1) — see statusLocked. -->
                <div class="toggle-button row" [ngClass]="{'disabled-div': statusLocked}">
                    <div class="col-10 p-0">
                        <p>Status of the Promotion.</p>
                    </div>
                    <div class="col-2 p-0 switch">
                        <input type="checkbox" formControlName="status" [checked]="form.value.status == 1" (change)="onChangeStatus($event, 'status')" [attr.disabled]="statusLocked ? true : null">
                        <div class="slider round">
                            <span class="on">ON</span>
                            <span class="off">OFF</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Section 2 — Free Spin configuration. BTG has no fields here, so the heading is gated too.
             Each logical group gets its own .row: conditional fields (Recurring / Reset Day) then
             can't reflow the groups below them. -->
        <ng-container *ngIf="initialData.promotion_type == 'PP Promotion' || initialData.promotion_type == 'Free Spin'">
            <div class="mb-3">
                <span class="section-heading"><span class="section-heading-rule"></span>Bonus Setting</span>
            </div>

            <!-- PP Promotion (unchanged): single hardcoded PP game dropdown -->
            <div class="row" *ngIf="initialData.promotion_type == 'PP Promotion'">
                <div class="col-4 mb-4">
                    <span class="kt-font-bold">Free Spin Games <span class="text-danger">*</span>
                    <p class="float-right" style="font-weight: 300; font-size: 11px;">Pragmatic Play</p>
                    </span>
                    <kt-dropdown-wo-lazyload
                        [form] = 'form'
                        [dropdownList] = "freeSpinGameDropdownList"
                        [dropdownSettings] = 'freeSpinGameDropdownSettings'
                        [formName] = "'free_spin_game_code'"
                        [selectionAttributes] = "'code'"
                        [selectedItems] = freeSpinGameSelectedList
                        [dataLoading]="isFreeSpinGameLoading">
                    </kt-dropdown-wo-lazyload>
                </div>
            </div>

            <!-- Free Spin (AIO-71840): Type + schedule, then reward config -->
            <ng-container *ngIf="initialData.promotion_type == 'Free Spin'">
                <div class="row">
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Type <span class="text-danger">*</span></span>
                        <select formControlName="promo_sub_type" class="form-control" [attr.disabled]="isEditMode ? true : null" (change)="onPromoSubTypeChange()">
                            <option [ngValue]="1">Welcome</option>
                            <option [ngValue]="2">Reload</option>
                        </select>
                    </div>
                    <div class="col-4 mb-4" *ngIf="!hideRecurring">
                        <span class="kt-font-bold">Recurring <span class="text-danger">*</span></span>
                        <select formControlName="reset_frequency" class="form-control" (change)="onSetRecurring()">
                            <option [ngValue]="0">One Time</option>
                            <option [ngValue]="1">Daily</option>
                            <option [ngValue]="2">Weekly</option>
                            <option [ngValue]="3">Monthly</option>
                        </select>
                    </div>
                    <!-- Reset Day as chips instead of a second dropdown, filling the third column
                         next to Recurring. Single-select: reset_day is one integer, not a list. -->
                    <div class="col-4 mb-4" *ngIf="!hideRecurring && (+form.value.reset_frequency === 2 || +form.value.reset_frequency === 3)">
                        <span class="kt-font-bold">Reset Day <span class="text-danger">*</span></span>
                        <div class="day-picker">
                            <button type="button" class="day-picker-chip" *ngFor="let opt of resetDayOptions"
                                [class.selected]="isResetDaySelected(opt.id)" (click)="selectResetDay(opt.id)">{{ opt.name }}</button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Free Spin Game Provider <span class="text-danger">*</span></span>
                        <!-- Edit: read-only, displayed like the Code field -->
                        <!-- The label comes from the provider list, so show a spinner until it loads -->
                        <div *ngIf="isEditMode" style="position: relative;">
                            <input type="text" class="form-control disabled" [value]="freeSpinProviderLabel" disabled/>
                            <i *ngIf="isFreeSpinProviderLoading" class="spinner-border spinner-border-sm" style="position: absolute; right: 15px; top: calc(50% - 0.5rem);"></i>
                        </div>
                        <div *ngIf="!isEditMode" [ngClass]="(freeSpinGameProviderDisabled || isFreeSpinProviderLoading) ? 'disabled-div' : ''">
                            <kt-dropdown-wo-lazyload
                                [form] = 'form'
                                [dropdownList] = "freeSpinGameProvidersDropdownList"
                                [dropdownSettings] = 'freeSpingameProvidersDropdownSettings'
                                [formName] = "'free_spin_game_provider_id'"
                                [selectionAttributes] = "'id'"
                                [selectedItems] = freeSpinGameProvidersSelectedList
                                [dataLoading]="isFreeSpinProviderLoading"
                                (selectedItemsChanged)="onFreeSpinGameProviderChange($event)">
                            </kt-dropdown-wo-lazyload>
                        </div>
                    </div>
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Free Spin Games <span class="text-danger">*</span></span>
                        <!-- Edit: read-only, displayed like the Code field -->
                        <div *ngIf="isEditMode" style="position: relative;">
                            <input type="text" class="form-control disabled" [value]="freeSpinGameLabel" disabled/>
                            <i *ngIf="isFreeSpinGameLoading" class="spinner-border spinner-border-sm" style="position: absolute; right: 15px; top: calc(50% - 0.5rem);"></i>
                        </div>
                        <div *ngIf="!isEditMode" [ngClass]="(freeSpinGameDisabled || isFreeSpinGameLoading) ? 'disabled-div' : ''">
                            <kt-dropdown-wo-lazyload
                                [form] = 'form'
                                [dropdownList] = "freeSpinGameDropdownList"
                                [dropdownSettings] = 'freeSpinGameDropdownSettings'
                                [formName] = "'free_spin_game_code'"
                                [selectionAttributes] = "'code'"
                                [selectedItems] = freeSpinGameSelectedList
                                [dataLoading]="isFreeSpinGameLoading">
                            </kt-dropdown-wo-lazyload>
                        </div>
                    </div>
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Rewards Validity</span>
                        <input type="number" (wheel)="false" min="0" class="form-control" formControlName="reward_validity" (keydown)="onNumberKeydown($event)" (paste)="onPaste($event)" placeholder="0 = unlimited"/>
                        <span class="reminder-text">Enter 0 for unlimited</span>
                    </div>
                </div>
            </ng-container>

            <!-- Launch restrictions — shared by PP Promotion and Free Spin -->
            <div class="row">
                <div class="col-4 mb-4">
                    <span class="kt-font-bold">Claim If Bonus Round Active
                        <i class="fas fa-exclamation-circle" matTooltip='If ticked, promotion will prevent players with ongoing free spin on the game provider from claiming the promotion.' matTooltipClass="custom-tooltip" matTooltipHideDelay="0"></i>
                    </span>
                    <div class="toggle-button row" [ngClass]="{'disabled-div': initialData.promotion_type == 'Free Spin'}">
                        <div class="col-10 p-0">
                            <p>Restrict</p>
                        </div>
                        <div class="col-2 p-0 switch">
                            <input type="checkbox" formControlName="restrict_claim_round_active" [checked]="form.value.restrict_claim_round_active == 1" (change)="onChangeStatus($event, 'restrict_claim_round_active')">
                            <div class="slider round">
                                <span class="on">ON</span>
                                <span class="off">OFF</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4 mb-4">
                    <span class="kt-font-bold">Same Provider Game Launch
                        <i class="fas fa-exclamation-circle" matTooltip='If ticked, players who claimed the bonus will be prevented from launching games from the same provider not linked to the claimed promotion.' matTooltipClass="custom-tooltip" matTooltipHideDelay="0"></i>
                    </span>
                    <div class="toggle-button row">
                        <div class="col-10 p-0">
                            <p>Restrict</p>
                        </div>
                        <div class="col-2 p-0 switch">
                            <input type="checkbox" formControlName="restrict_same_provider_launch" [checked]="form.value.restrict_same_provider_launch == 1" (change)="onChangeStatus($event, 'restrict_same_provider_launch')">
                            <div class="slider round">
                                <span class="on">ON</span>
                                <span class="off">OFF</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Validity (AIO-71840) — claim window in days, mirrors v1's 1–30 range.
                     Sits in this row's third column so it lines up under Rewards Validity. -->
                <div class="col-4 mb-4" *ngIf="initialData.promotion_type == 'Free Spin'">
                    <span class="kt-font-bold">Validity</span>
                    <input type="number" (wheel)="false" min="1" max="30" class="form-control" formControlName="validity" (keydown)="onNumberKeydown($event)" (paste)="onPaste($event)"/>
                    <span class="reminder-text">Enter 1 to 30 days</span>
                </div>
            </div>

            <!-- Frequency (frequency_type / frequency) has no UI on purpose — see formInit().
                 The form controls still carry the values so create submits 1 and edit preserves
                 whatever is stored. -->
        </ng-container>
    </form>
  </div>
</div>
